import React from "react";
import Card from "react-bootstrap/Card";
import { Col, Row } from "react-bootstrap";
import BoxData from "../../pages/NewDashboard/Component/Box";
import CardNav from "../../pages/NewDashboard/Component/CardNav";
import { images } from "../../constants";
import "../../pages/NewDashboard/Component/BussinessMode/style.css";

// JSON data with full step-by-step info
export const BuyingBusinessData = [
  {
    id: 1,
    title: "Retailer Markets",
    titleone: "Retailer's",
    info: (
      <>
        <p>
          <strong>Retailer Markets</strong> are online showcases of local and
          global retail shops where consumers can explore stores without
          physically visiting them. It's for{" "}
          <strong>Business-to-Consumer (B2C)</strong> connectivity.
        </p>
        <p>
          Users can search shop showcases from nearby locations to anywhere in
          the world. This section represents only retailer markets, meaning
          general shops where consumers buy daily-use items such as{" "}
          <strong>groceries, household goods, clothing, and essentials</strong>.
        </p>
        <p>
          Through the retail market showcase, users can view the entire shop
          remotely from home, browse products, and understand what the store
          offers before deciding to visit or make a purchase.
        </p>
        <p>
          <strong>Retail Markets</strong> make shopping convenient, time-saving,
          and accessible, connecting consumers directly with retailers across
          different locations.
        </p>
        <a href="https://www.youtube.com" target="_blank">
          <strong>Click here to see how to Explore the Market</strong>
        </a>
      </>
    ),
  },
  {
    id: 2,
    title: "Wholesale Markets",
    titleone: "WholeSeller's",
    info: (
      <>
        <p>
          <strong>Wholesale Markets</strong> are designed specifically for
          business professionals and entrepreneurs. It's for{" "}
          <strong>Business-to-Business (B2B)</strong> connectivity.
        </p>
        <p>
          This platform operates as a <strong>B2B system</strong>, where only
          business users can participate. To access the wholesale market, users
          must create a <strong>business shop profile</strong> first, which
          allows them to communicate and collaborate directly with wholesalers.
          Go to the <strong>“Business Creation Shop showcase”</strong> and
          create your own shop to connect with wholesalers.
        </p>
        <p>
          Once registered, users can connect with multiple wholesale suppliers,
          compare options, and choose the best products or services to establish
          or expand their business in the market.
        </p>
        <p>
          The platform supports businesses by offering multiple opportunities,
          supplier choices, and networking tools, helping them grow and succeed
          efficiently.
        </p>
        <a href="https://www.youtube.com" target="_blank">
          <strong>Click here to see how to Explore the Market</strong>
        </a>
      </>
    ),
  },
  {
    id: 3,
    title: "Industrial Markets",
    titleone: "Industrial's",
    info: (
      <>
        <p>
          <strong>Industrial Markets</strong> are designed for business
          professionals who want to connect directly with{" "}
          <strong>manufacturers</strong>. It's for{" "}
          <strong>Business-to-Business (B2B)</strong> connectivity.
        </p>
        <p>
          To access this platform, users must become a{" "}
          <strong>Retailer or Wholesaler</strong> by creating a business shop
          profile. This allows them to visit the Industrial Market and
          communicate directly with manufacturers. Go to the{" "}
          <strong>“Business Creation Shop showcase”</strong> and create your own
          shop to connect with manufacturers.
        </p>
        <p>
          The Industrial Market functions as a B2B resource system exclusively
          for registered business users. Retailers and wholesalers can explore
          multiple sourcing options, build manufacturer relationships, and
          establish or grow their presence in the market.
        </p>
        <p>
          Once you create your shop and become a verified business, the platform
          supports you with multiple opportunities, supplier choices, and tools
          to scale your business successfully.
        </p>
        <a href="https://www.youtube.com" target="_blank">
          <strong>Click here to see how to Explore the Market</strong>
        </a>
      </>
    ),
  },
  {
    id: 4,
    title: "Raw Material Markets",
    titleone: "Raw Material's",
    info: (
      <>
        <p>
          <strong>Raw Material Supplier Markets</strong> are specialized
          platforms designed for manufacturers and industrialists to connect
          directly with <strong>raw material producers</strong>. It's for{" "}
          <strong>Business-to-Business (B2B)</strong> connectivity.
        </p>
        <p>
          Only verified manufacturers who produce finished goods are allowed to
          access this market. They can communicate and collaborate with raw
          material producing companies such as{" "}
          <strong>
            mining firms, agricultural producers, and raw material stockists
          </strong>
          .
        </p>
        <p>
          To access the market, users must create a shop profile as a{" "}
          <strong>Manufacturer or Industrialist</strong>. Once registered, the
          platform provides multiple sourcing options, helping manufacturers
          secure reliable raw materials and strengthen their supply chain.
        </p>
        <p>
          This market operates as a B2B resource system, focused on{" "}
          <strong>
            efficiency, transparency, and long-term industrial growth
          </strong>
          .
        </p>
      </>
    ),
  },
];

const BuyingBusinessModes = ({ btntext }) => {
  const boxConfig = {
    1: {
      img: images.Retailer,
      url: "/retailer-integrate",
      link: "/buy-retailer",
      ms: "eight-element",
      buy: "eight",
    },
    2: {
      img: images.WholeSaler,
      url: "/wholeseller-integrate",
      link: "/buy-wholeseller",
      ms: "six-element",
      buy: "six",
    },
    3: {
      img: images.Factory,
      url: "/manufacturer-integrate",
      link: "/buy-manufacturer",
      ms: "seven-element",
      buy: "seven",
    },
    4: {
      img: images.IronLogo,
      url: "/raw-integrate",
      link: "/buy-raw-material",
      ms: "eight-element",
      buy: "eight",
    },
  };

  return (
    <div>
      <Row className="set-one set-onetwo">
        {BuyingBusinessData.map((data) => {
          const config = boxConfig[data.id];
          return (
            <Col key={data.id} lg="3" md="3" sm="6" xs="6">
              {/* CardNav shows title + info */}
              <CardNav
                Header={data.title}
                para={data.info}
                myinfo={data.info}
                myid={data.id}
              />

              {/* BoxData card */}
              <Card className="shadow-main mt-2 p-3">
                {config && (
                  <BoxData
                    Butonn={btntext}
                    imgg={config.img}
                    url={config.url}
                    link={config.link}
                    ms={config.ms}
                    buy={config.buy}
                    Title={data.titleone}
                  />
                )}
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default BuyingBusinessModes;
